// function that does special character escaping .*+?|()[]{}\$^
export const escapeSpecialChars = str => {
  const specials = /[.*+?|()\[\]{}\\$^]/g; // .*+?|()[]{}\$^

  return str.replace(specials, '\\$&');
};

export const searchPhraseRegExp = searchPhrase => {
  return new RegExp('(' + escapeSpecialChars(searchPhrase) + ')', 'gi');
};

export function highlightFillerWords(phrase, className) {
  const fillerRegExp = new RegExp(/\b[Uu][mh]\b/, 'gi');

  return phrase.replace(fillerRegExp, match => {
    return `<mark class='${className}'>${match}</mark>`;
  });
}

// function that replaces all instances of the searched phrase in
// the phrase value with the searched phrase surrounded by mark tags
export const replaceSearchWordsInPhrase = (
  phraseValue,
  searchPhrase,
  baseClass = '',
  activeClass = '',
  searchIndex = 0
) => {
  let counter = 0;

  try {
    return phraseValue.replace(searchPhraseRegExp(searchPhrase), match => {
      let currentClass = baseClass;

      if (searchIndex === counter) {
        currentClass += ` ${activeClass}`;
      }

      const highlight = `<mark class='${currentClass}' data-index=${counter}>${match}</mark>`;

      counter += 1;

      return highlight;
    });
  } catch (err) {
    console.warn('Error replacing search words in phrase', err);

    if (err) {
      return phraseValue;
    }
  }
};

// function that returns all indices of of the searchPhrase
// in phrases transcript array
export const findIndicesOfSearchPhraseInPhrases = (searchPhrase, phrases) => {
  searchPhrase = searchPhrase.trim();

  if (!searchPhrase || phrases.length < 1) {
    return [];
  }

  const result = [];

  try {
    const regex = searchPhraseRegExp(searchPhrase);

    phrases.forEach((phraseObj, index) => {
      const phrase = phraseObj.value;
      let counter = 0;

      while (regex.exec(phrase)) {
        result.push({ index, counter });
        counter++;
      }
    });

    return result;
  } catch (err) {
    console.warn('Error finding indices of Search Phrase In Phrases', err);

    return [];
  }
};
